import React from 'react'
import MaterialSelect from '../../../../components/MasterSelect'
import MaterialTypography from '../../../../components/MaterialTypography'
import MaterialInput from '../../../../components/MaterialInput'
import Grid from "@mui/material/Grid2";
import MaterialBox from '../../../../components/MaterialBox';
import { FormControl,FormHelperText } from '@mui/material';
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
function Encashment ({
    handleChange,
    togglePage,
    handleleaveconfigdataChange,
    leaveconfigdata,
    lossofpaydata,
    handleencashment
}) {
  return (
    <MaterialBox>
           <Grid mt={4} container spacing={2}>
                    <Grid ml={2}>
                      <MaterialBox lineHeight={0} display="inline-block">
                        <MaterialTypography
                          component="label"
                          variant="caption"
                          fontWeight="bold"
                        >
                          Encashment
                        </MaterialTypography>
                      </MaterialBox>
                      <FormControlLabel
                        sx={{ marginLeft: "0%" }}
                        control={
                          <Switch
                            checked={leaveconfigdata.encashment}
                            onChange={(e) =>
                              handleleaveconfigdataChange({
                                target: {
                                  name: "encashment",
                                  value: e.target.checked,
                                },
                              })
                            }
                            color="primary"
                          />
                        }
                        label={leaveconfigdata.encashment ? "Yes" : "No"}
                        disabled={togglePage.view === true ? true : false}
                      />
                    </Grid>
                    <Grid ml={2} size={{ xs: 4, sm: 4 }}>
                      <MaterialBox lineHeight={0} display="inline-block">
                        <MaterialTypography
                          component="label"
                          variant="caption"
                          fontWeight="bold"
                        >
                          Maximum Encashment Days 
                        </MaterialTypography>
                      </MaterialBox>
                      <MaterialInput
                        name="maximumencashmentdays"
                        onChange={handleChange}
                        value={leaveconfigdata.maximumencashmentdays}
                        error={
                          leaveconfigdata.maximumencashmentdaysStatus ===
                          "error"
                        }
                        success={
                          leaveconfigdata.maximumencashmentdaysStatus ===
                          "success"
                        }
                        disabled={
                          togglePage.view === true ||
                          !leaveconfigdata.encashment
                        }
             
                      />
                      {leaveconfigdata.maximumencashmentdaysStatus ===
                        "error" && (
                        <FormControl error>
                          <FormHelperText>
                            Should accept only Numbers maximum of two characters
                          </FormHelperText>
                        </FormControl>
                      )}
                    </Grid>
                    <Grid ml={2} size={{ xs: 4, sm: 4 }}>
                      <MaterialBox lineHeight={0} display="inline-block">
                        <MaterialTypography
                          component="label"
                          variant="caption"
                          fontWeight="bold"
                        > 
                        Encashment From 
                        </MaterialTypography>
                      </MaterialBox>
                     <MaterialSelect
                       name='encashmentfrom'
                               value={leaveconfigdata?.encashmentfrom}
                               onChange={handleencashment}
                               error={leaveconfigdata.encashmentfromStatus === "error"}
                               success={leaveconfigdata.encashmentfromStatus === "success"}
                               isDisabled={togglePage.view === true ? true : false}
                               options={lossofpaydata.map((item) => {
                                 return {
                                   value: item?.value,
                                   label: item?.label,
                                 };
                               })}
                             />
                   
                    </Grid>
                  </Grid>
    </MaterialBox>
  )
}

export default Encashment 